// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Share: React.FC = () => {
    return <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 19 20" enableBackground="new 0 0 19 20" xmlSpace="preserve" fill="currentColor">
<path d="M14.71,8.68c2.14,0,3.89-1.75,3.89-3.89S16.85,0.9,14.71,0.9c-2.15,0-3.89,1.75-3.89,3.89c0,0.69,0.2,1.33,0.51,1.89
	l-5.48,3.49C5.27,9.7,4.54,9.4,3.74,9.4c-1.84,0-3.34,1.5-3.34,3.34s1.5,3.34,3.34,3.34c1.15,0,2.17-0.59,2.77-1.48l4.59,1.84
	c0.07,1.48,1.29,2.66,2.78,2.66c1.54,0,2.79-1.25,2.79-2.79s-1.25-2.79-2.79-2.79c-1.16,0-2.16,0.71-2.58,1.72L6.99,13.5
	c0.06-0.25,0.1-0.5,0.1-0.76c0-0.6-0.17-1.16-0.45-1.65l5.44-3.46C12.76,8.28,13.69,8.68,14.71,8.68z M13.89,14.71
	c0.88,0,1.59,0.71,1.59,1.59s-0.72,1.59-1.59,1.59s-1.59-0.71-1.59-1.59S13.01,14.71,13.89,14.71z M14.71,2.1
	c1.48,0,2.69,1.21,2.69,2.69s-1.21,2.69-2.69,2.69s-2.69-1.21-2.69-2.69S13.23,2.1,14.71,2.1z M3.74,14.88
	c-1.18,0-2.14-0.96-2.14-2.14c0-1.18,0.96-2.14,2.14-2.14s2.14,0.96,2.14,2.14C5.88,13.92,4.92,14.88,3.74,14.88z"/>
</svg>;
};

export default React.memo(Share);
